import React from 'react';
import Chart from './components/Chart'
import axios from 'axios'
import Socket from './components/Socket'

class App extends React.Component {
  constructor(){
    super()
    this.state = {
      chartData: {},
      responseData: []
    }
  }
  componentWillMount() {
    this.getChartData()
  }

  getChartData() {
    // Ajax Calls here
    axios.get(`https://www.eyemotion.me/chart/export.json`)
    .then( res => {
//      console.log(res.data.Items)
      this.setState({ responseData: res.data })
      console.log(this.state.responseData.Items[0].average.S)
    })

    this.setState({
      chartData: {
        labels: ['January', 'February', 'March', 'April','May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [
          {
            label: 'Detected Persons',
            data: [1,2,
              5, 8, 2, 10, 12, 2,2, 5, 7, 3, 9],
            backgroundColor: [
              'rgba(255, 99, 132, 0.6)',
              'rgba(54, 162, 235, 0.6)',
              'rgba(75, 192, 192, 0.6)',
              'rgba(153, 102, 255, 0.6)',
              'rgba(56, 150, 132, 0.6)',
              'rgba(2, 63, 98, 0.6)',
              'rgba(255, 99, 132, 0.6)',
              'rgba(54, 162, 235, 0.6)',
              'rgba(75, 192, 192, 0.6)',
              'rgba(153, 102, 255, 0.6)',
              'rgba(56, 150, 132, 0.6)',
              'rgba(2, 63, 98, 0.6)',
            ]
          }
        ]
      }
    })
  }

  render() {
    return (
      <div className = "App" >
        <Chart chartData={this.state.chartData} legendPosition="bottom"/>
        {/*<Socket /> */}
      </div>
    );
}
}
export default App;
